import { BaseEntity } from 'yt-ng-framework';
export class NetoOtkupniFond extends BaseEntity{
    constructor(){
        super();
    }

    OrgJed: string = null;
    Valuta: string = null;
    Datum: Date = null;
    IznosValuteUlaz: number = null;
    IznosValuteIlzlaz: number = null;
    Razlika: number = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.OrgJed=input.OrgJed;
        this.Valuta = input.Valuta;
        this.Datum = input.Datum;
        this.IznosValuteUlaz =this.blankIfZero(input.IznosValuteUlaz);
        this.IznosValuteIlzlaz = this.blankIfZero(input.IznosValuteIlzlaz);
        this.Razlika = this.blankIfZero(input.Razlika);
    
        return this;
    }

    Serialize(input: NetoOtkupniFond){
        return input;
    }

    blankIfZero(value){
        return value == 0 ? "" : value;
    }

}   